import { clsx } from "clsx";
import type { FC, CSSProperties } from "react";

interface ILoadingSpinner {
  className?: string;
  size?: "sm" | "md" | "lg" | "xl";
  style?: CSSProperties;
}

const LoadingSpinner: FC<ILoadingSpinner> = function ({
  className,
  size = "md",
  style,
}) {
  const sizeClasses = {
    sm: "h-3 w-3",
    md: "h-4 w-4",
    lg: "h-6 w-6",
    xl: "h-8 w-8",
  };

  return (
    <div className="flex items-center justify-center h-fit" style={style}>
      <div className="text-center">
        <div
          className={clsx(
            "animate-spin rounded-full border-b-2 border-blue-600 mx-auto",
            sizeClasses[size],
            className
          )}
        />
      </div>
    </div>
  );
};

export default LoadingSpinner;
